import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { colors } from 'styles/colors';
import { devices } from 'styles/devices';

const Container = styled.div`
   background: ${colors.white};
   color: ${colors.black};
   border-radius: 2rem;
   padding: 1rem;
   max-width: 300px;
   margin-top: 2rem;

   ${devices.tablet} {
      font-size: 1.25rem;
      padding: 2rem;
      margin: auto;
   }
`;

const PasswordChanged = () => {
   return (
      <Container>
         <span>
            <FormattedMessage id="PasswordChanged" />
            <br />
            <FormattedMessage id="SignInBelow" />
         </span>
      </Container>
   );
};

export default PasswordChanged;
